<template>
    <div class="padding-settings text-center">
            <div style="border:1px solid lightgrey;text-align:center;display:inline-block;">
                <table>
                    <tbody>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <drag-input-unit 
                                    :min="0"
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                	:value='styleJSON.paddingTop' 
                                	icon="arrow-to-top"
                                	@input="(value)=>{
                                        if(currentGroup === 2 ) return setAll(value);
                                		setStyle({paddingTop:value});
                                		if(currentGroup === 1){
                                			setStyle({paddingBottom:value});
                                		}
                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <drag-input-unit 
                                    :min="0"
                                	:value='styleJSON.paddingLeft' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-left"
                                	@input="(value)=>{
                                        if(currentGroup === 2 ) return setAll(value);
                                		setStyle({paddingLeft:value});
                                		if(currentGroup === 1){
                                			setStyle({paddingRight:value});
                                		}
                                	}" 
                                />
                            </td>
                            <td>
                            <div style="border:1px dashed grey;padding:6px; display:inline-block;">
                                <btn 
                                    v-for="(icon,index) in ['expand','arrows','square']" 
                                    :key="index"
                                    :icon="icon" 
                                    s="xs" 
                                    :active="currentGroup === index" 
                                    @press="currentGroup = index" 
                                />
                            </div>
                            </td>
                            <td >
                                <drag-input-unit 
                                    :min="0"
                                	:value='styleJSON.paddingRight' 
                                    :style="{background:['white','#b7f7ff','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-right"
                                	@input="(value)=>{
                                        if(currentGroup === 2 ) return setAll(value);
                                		setStyle({paddingRight:value});
                                		if(currentGroup === 1){
                                			setStyle({paddingLeft:value});
                                		}
                                	}"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <drag-input-unit 
                                    :min="0"
                                	:value='styleJSON.paddingBottom' 
                                    :style="{background:['white','#a0ffa0','whitesmoke'][currentGroup]}"
                                	icon="arrow-to-bottom"
                                	@input="(value)=>{
                                        if(currentGroup === 2 ) return setAll(value);
                                		setStyle({paddingBottom:value});
                                		if(currentGroup === 1){
                                			setStyle({paddingTop:value});
                                		}

                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>
<script>

export default {
    name: "padding-settings",
    data() {
        return {
            currentGroup: 0
        }
    },
    methods:{
        setAll(value){
            this.setStyle({
                paddingLeft:value,
                paddingRight:value,
                paddingTop:value,
                paddingBottom:value
            });
        }
    },
    props: {
        setStyle: Function,
        styleJSON: {type:Object,default:{value:0, unit:'px'}}
    }
}
</script>
<style scoped>
.btnGroupVertical .btn {
    width: 18px;
}
</style>